<script setup>
import { ref } from "vue";
import { StealieButton, StealieHeading, StealieText } from "@get-overalls/fe-stealie";
import { sendAnswers } from "@/services/TemporaryAnswerService";
import { useRouter } from "vue-router";
import WelcomeLayout from "@/layouts/WelcomeLayout.vue";

const router = useRouter();

const options = ref([
  {
    image_url: "/illustrations/home.svg",
    id: "132",
    label: "I own a home",
    value: false,
  },
  {
    image_url: "/illustrations/car.svg",
    id: "134",
    label: "I own / lease a car",
    value: false,
  },
  {
    image_url: "/illustrations/child.svg",
    id: "121",
    label: "I am a parent",
    value: false,
  },
  {
    image_url: "/illustrations/pet-collar.svg",
    id: "122",
    label: "I have a pet",
    value: false,
  },
  {
    image_url: "/illustrations/partner.svg",
    id: "120",
    label: "I have a partner",
    value: false,
  },
]);

const handleSubmit = async () => {
  const answers = options.value.map((option) => ({
    answer_id: option.id,
    value: option.value,
  }));
  try {
    await sendAnswers(answers);
    router.push({ name: "ContactInfo" });
  } catch (error) {
    console.error("Error submitting answers:", error);
  }
};
</script>

<template>
  <WelcomeLayout progress-step="2">
    <div class="mx-auto flex w-fit flex-col items-center gap-y-8 sm:px-4">
      <StealieHeading
        level="1"
        size="lg"
        class="!text-3xl sm:self-start sm:!text-h1 sm:text-balance"
        data-sr-unmask
      >
        Discovering where we can help.
      </StealieHeading>

      <form id="about-you-form" class="mx-auto" @submit.prevent="handleSubmit">
        <fieldset class="mx-auto block w-fit min-w-[80vw]">
          <StealieText
            id="question-responsible-for"
            as="legend"
            size="lg"
            bold
            class="mb-6"
            data-sr-unmask
          >
            Select all that describe you:
          </StealieText>
          <div
            class="grid grid-cols-2 justify-center gap-4 sm:grid-cols-[repeat(auto-fill,176px)] md:justify-start xl:max-w-(--breakpoint-xl)"
          >
            <label
              v-for="option in options"
              :key="option.name"
              :class="[
                'inline-flex h-52 cursor-pointer flex-col items-center rounded-lg px-4 pt-10 pb-6 text-center',
                'border-2 border-brand-gray-50 bg-white text-brand-gray-600',
                'hover:bg-brand-primary-teal-50 hover:text-brand-black',
                'has-[input:checked]:border-brand-primary-teal-400 has-[input:checked]:bg-brand-primary-teal-50 has-[input:checked]:text-brand-black',
                'has-[input:focus-visible]:ring-2 has-[input:focus-visible]:ring-focus-highlight-light has-[input:focus-visible]:ring-offset-2 has-[input:focus-visible]:outline-none',
              ]"
            >
              <img :src="option.image_url" alt="" class="h-24 w-24" />
              <span class="text-center">
                {{ option.label }}
                <input
                  class="sr-only"
                  aria-describedby="question-responsible-for"
                  type="checkbox"
                  :name="option.id"
                  :checked="option.value"
                  @change="option.value = !option.value"
              /></span>
            </label>
          </div>
        </fieldset>
      </form>
      <div class="flex gap-x-4" data-sr-unmask>
        <StealieButton variant="secondary" :to="{ name: 'AboutUs' }">Back</StealieButton>
        <StealieButton form="about-you-form" type="submit">Next</StealieButton>
      </div>
    </div>
  </WelcomeLayout>
</template>
